import { toast } from 'react-toastify';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { apiRouts } from '../../constants';

class GetFileName {
  getUploadFileName = async (count) => {
    try {
      const { data } = await axios.get(
        `${apiRouts.getUploadFileName}/upload/getfilename${count ? `?number=${count}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return data;
    } catch (err) {
      toast.error(err?.response?.data.message || err.message);
      return null;
    }
  };

  getPermitUploadFileName = async (count) => {
    let file = [];
    try {
      for (let i=1; i<=count; i++) {
          const data = uuidv4();
          file.push(data);
      }
      return { 'filename': file };
    } catch (err) {
      toast.error(err?.response?.data.message || err.message);
      return null;
    }
  }

  getPublicUploadFileName = async (count, airportCode, entity, index='') => {
    let file = [];
    if (entity ==='badgingListA') {
      try {
        for (let i=1; i<=count; i++) {
             const data = `${Math.floor(Date.now() / 1000)}_${airportCode}_${i}A${index}`;
             file.push(data);
         }
         return { 'filename': file };
     } catch (err) {
       toast.error(err?.response?.data.message || err.message);
       return null;
   }
    } else if (entity ==='badgingListB') {
      try {
        for (let i=1; i<=count; i++) {
             const data = `${Math.floor(Date.now() / 1000)}_${airportCode}_${i}B${index}`;
             file.push(data);
         }
         return { 'filename': file };
     } catch (err) {
       toast.error(err?.response?.data.message || err.message);
       return null;
   }
  } else if (entity ==='badgingListC') {
      try {
        for (let i=1; i<=count; i++) {
             const data = `${Math.floor(Date.now() / 1000)}_${airportCode}_${i}C${index}`;
             file.push(data);
         }
         return { 'filename': file };
      } catch (err) {
       toast.error(err?.response?.data.message || err.message);
       return null;
      }
  } else if (entity==='driver_permit') {
      try {
        for (let i=1; i<=count; i++) {
             const data = uuidv4();
             file.push(data);
         }
         return { 'filename': file };
     } catch (err) {
       toast.error(err?.response?.data.message || err.message);
       return null;
   }
    } else {
    try {
       for (let i=1; i<=count; i++) {
            const data = `${Math.floor(Date.now() / 1000)}_${airportCode}_${i}`;
            file.push(data);
        }
        return { 'filename': file };
    } catch (err) {
      toast.error(err?.response?.data.message || err.message);
      return null;
  }
  }
}
}


const Service = new GetFileName();

export default Service;
export { Service as GetFileName };
